module.exports = __webpack_public_path__ + "static/5-1009ac60e5edccbfee9f5cab1e8a6dae.png";